// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"208":"custom-fields","3388":"float-price"}[chunkId] + "." + {"208":"93b1f776","3388":"e4659e19"}[chunkId] + ".css";
};